import { debounce } from 'lodash-es';

var $aside = $('#aside'),
    $catelog = $('#catalog');
function getAsideWith() {
  return $aside.width();
}
function setCatalogWidth() {
  var asideWidth = getAsideWith();
  $catelog.css('width', asideWidth);
}
setCatalogWidth();
$(window).on('resize', debounce(function () {
  setCatalogWidth();
}, 500));
